








import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class ActivityIndicator extends Vue {
  @Prop(String) private size!: number | string;
  private data() {
    return {
      chosenSize: 30 || this.$props.size,
    };
  }
}
